module.exports = __webpack_public_path__ + "media/images/app/browser-80b7f4fe1ccec53ed5150626ac45a252.svg";